module.exports = __webpack_public_path__ + "static/media/beaver.9c893dfb.svg";